import { MunicipalPropertyListInput } from "@/graphql/generated/graphql";
import { MUNICIPAL_PROPERTY_LIST_PAGE_SIZE } from "@ark/shared";

import { MunicipalPropertyCatalogFilter } from "./municipal-property-catalog-filter.model";

interface ToMunicipalPropertyListInputOptions {
  workspaceId: string;
  filter: MunicipalPropertyCatalogFilter;
  after?: string;
}

export function toMunicipalPropertyListInput({
  workspaceId,
  filter,
  after,
}: ToMunicipalPropertyListInputOptions): MunicipalPropertyListInput {
  return {
    workspaceId,
    ...(filter.inventoryId ? { inventoryId: filter.inventoryId } : {}),
    first: MUNICIPAL_PROPERTY_LIST_PAGE_SIZE.default,
    after: after ?? null,
    municipalityId: filter.municipalityId,
    search: filter.search.trim() || null,
    excludeRegisterId: filter.excludeRegisterId ?? null,
    lifecycle: filter.lifecycle,
    isUsed: filter.usage === "ALL" ? null : filter.usage === "USED",
  };
}
